import { render, staticRenderFns } from "./locationList.vue?vue&type=template&id=b1171de6&scoped=true&"
import script from "./locationList.vue?vue&type=script&lang=js&"
export * from "./locationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1171de6",
  null
  
)

export default component.exports